<template>
    <div class="l-wrap">
        <div class="l-constrained l-content proposal">
            <el-container v-loading="! initialized">
                <el-form style="width:100%">

                    <el-row>
                        <el-col :span="12">
                            <h1>Proposal</h1>
                        </el-col>
                        <el-col :span="12" style="text-align: right;">
                            <btn icon="fas fa-step-backward" :click="goBack">Go Back to Proposals</btn>
                            <btn icon="fas fa-step-backward" :disabled="!form_data.employer_id" :click="goToEmployerDetail">Go Back to Employer's Proposals</btn>
                            <btn icon="fas fa-copy" :click="cloneProposal">Clone</btn>
                        </el-col>
                    </el-row>

                    <el-row v-if="form_data.signed_at">
                        <el-col :span="12" class="alert alert-danger">
                            This document is signed from the customer and can't be changed anymore.
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <h2>Company</h2>

                            <el-form-item v-if="form_data.employer_id" label="Employer Name">
                                <el-select v-model="form_data.employer_id" style="width:100%" filterable required="required">
                                    <el-option
                                        v-for="option in employers"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="`employer-${option.id}`">
                                        <span style="float: left">{{ option.name }} ({{ option.id }})</span>
                                        <span style="float: right">{{ option.state }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item v-else label="Employer Name">
                                <el-input v-model="form_data.name"></el-input>
                            </el-form-item>

                            <el-form-item label="Number of Recruiters" class="is-required">
                                <el-input v-model="form_data.number_of_recruiters" required="required"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <h2>Main Contact</h2>
                            <p>The system will invite the main contact into the customer portal when the proposal is signed.</p>

                            <el-form-item>
                                <el-input v-model="form_data.contact_name" placeholder="Name"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input v-model="form_data.contact_email" placeholder="Email"></el-input>
                            </el-form-item>
                            <el-checkbox v-model="form_data.grant_portal_access">Grant Employer access to Bluegrass</el-checkbox>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <h2>BUSINESS</h2>
                            <el-radio-group v-model="form_data.renewal_type">
                                <el-radio :label="0">New business</el-radio><br>
                                <el-radio :label="2">Renewal - this month</el-radio><br>
                                <el-radio :label="1">Renewal - next month</el-radio><br>
                            </el-radio-group>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <h2>FIRST BILLING MONTH</h2>
                            <div>Leave empty for default (15th+ is next month billing)</div>
                            <el-date-picker v-model="form_data.first_paid_month" type="month"/>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <h2>Billing</h2>

                            <el-radio-group v-model="form_data.billing_method">
                                <el-radio label="credit-card">Credit Card</el-radio><br>
                                <el-radio label="invoice">Invoice</el-radio><br>
                            </el-radio-group>
                        </el-col>
                    </el-row>

                    <JobFormMap v-if="initialized"
                                :google-api-key="google_api_key"
                                :area-id="form_data.area_id"
                                :maps-url="maps_url"
                                :is-tr-user="true"
                                :has-error="mapsHasError"/>

                    <el-row>
                        <el-col :span="24">
                            <h2>Audience</h2>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Min Experience">
                                <el-select v-model="form_data.min_cdl_xp" style="width:100%" required="required">
                                    <el-option
                                        v-for="option in globals.cdl_xp"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="`min-xp-${option.id}`"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Max Experience">
                                <el-select v-model="form_data.max_cdl_xp" style="width:100%">
                                    <el-option
                                        v-for="option in globals.cdl_xp"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="`max-xp-${option.id}`"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <proposal-categories  :formData="form_data"></proposal-categories>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" style="padding-bottom:20px">
                        <el-col :span="24">
                            <h2>Pricing</h2>
                            <el-radio-group v-model="form_data.jobadviser_pricing">
                                <el-radio label="equipment_based">New Pricing based on Equipment</el-radio><br>
                                <el-radio label="old">Old</el-radio><br>
                            </el-radio-group>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <el-form-item>
                                <btn :disabled="form_data.signed_at" :click="saveAudience" cssClass="btn btn-primary btn-lg">Save Audience and Get Results</btn>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <proposal-result :id="id"
                                     :formData="form_data"
                                     :results="results"
                                     v-if="!dirty && results"
                                     :show_mc="form_data.number_of_recruiters >= 3"
                    />
                </el-form>
            </el-container>
        </div>
    </div>
</template>

<script>
import JobFormMap from './../../../maps/vue/map.vue';
import ProposalCategories from './parts/proposal-categories';
import ProposalResult from "./parts/proposal-result";

export default {
    props: [
        'id',
        'form_data_input',
        'google_api_key',
        'maps_url'
    ],
    components: {
        ProposalResult,
        JobFormMap,
        ProposalCategories
    },
    data() {

        return {
            form_data: this.form_data_input,
            mapsHasError: false,
            employers: [],
            loading: false,
            area_ready: false,
            refresh_index: 1,
            results: null,
            dirty: false
        };
    },
    computed: {
        initialized() {
            return ! this.loading && this.area_ready;
        },
    },
    watch: {
        'form_data.employer_id': function() {
            this.form_data.name = _.find(this.employers, { id: this.form_data.employer_id }).name;
        },
        'form_data.renewal_type': function(rVal) {
            if (!this.form_data.signed_at && rVal !== 0) {
                this.form_data.grant_portal_access = false;
            }
        },
        form_data: {
            handler() {
                this.dirty = true;
            },
            deep: true
        }
    },
    methods: {
        startAreaSession(proposalId) {
            this.area_ready = false,

            axios.post(this.url(`admin/area/start-session`), {
                proposal_id: proposalId
            }).then(response => {
                this.form_data.area_id = response.data.id;

                this.area_ready = true;
            });
        },
        cloneProposal() {
            window.location.href = url(`admin/proposal/${this.id}/clone`);
        },
        goBack() {
            window.location.href = url(`admin/proposal/list`);
        },
        goToEmployerDetail() {
            window.location.href = url(`admin/employer/${this.form_data.employer_id}/proposals`);
        },
        saveAudience() {
            this.loading = true;
            return axios.post(url(`admin/proposal/${this.id}/update`), {
                'id': this.id,
                'name': this.form_data.name,
                'employer_id': this.form_data.employer_id,
                'area_id': this.form_data.area_id,
                'first_paid_month': this.form_data.first_paid_month,
                'min_cdl_xp': this.form_data.min_cdl_xp,
                'max_cdl_xp': this.form_data.max_cdl_xp,
                'categories': this.form_data.categories,
                'number_of_recruiters': this.form_data.number_of_recruiters,
                'jobadviser_pricing': this.form_data.jobadviser_pricing,
                'contact_name': this.form_data.contact_name,
                'contact_email': this.form_data.contact_email,
                'billing_method': this.form_data.billing_method,
                'grant_portal_access': this.form_data.grant_portal_access,
                'renewal_type': this.form_data.renewal_type,
            }).then((result) => {
                ++this.refresh_index;
                return this.refresh();
            }).finally(() => {
                this.loading = false;
                this.dirty = false;
            });
        },
        refresh() {
            this.startAreaSession(this.id);

            axios.get(url(`admin/employers/dropdown?inactive=1`))
                .then((response) => {
                    this.employers = response.data;
                });
            return axios.get(url(`admin/proposal/${this.id}/results`))
                .then((result) => {
                    this.results = result.data;
                });
        },
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
.proposal h2 {
    margin-top: 50px !important;
}
.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before, h2.is-required:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}
</style>
